import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import Contact from './pages/Contact';
import JumpFroggo from './pages/JumpFroggo';
import DriveSkillVR from './pages/DriveSkillVR';
import VRWalkthrough from './pages/VRWalkthrough';
import BathroomConfigurator from './pages/BathroomConfigurator';
import InoviqSpace from './pages/InoviqSpace';
import PixifyArchiWalkthrough from './pages/PixifyArchiWalkthrough';
import OfficeOutlawsPrivacyPolicy from './pages/OfficeOutlawsPrivacyPolicy';
import OfficeOutlaws from './pages/OfficeOutlaws';
import JumpFroggoPrivacyPolicy from './pages/JumpFroggoPrivacyPolicy';
import DeadInside from './pages/DeadInside';
import Assets from './pages/Assets';
import WebAR from './pages/WebAR';

const RedRenderSite: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/web-ar" element={<WebAR />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/jumpfroggo" element={<JumpFroggo />} />
          <Route path="/jumpfroggo-privacy-policy" element={<JumpFroggoPrivacyPolicy />} />
          <Route path="/driveskill-vr" element={<DriveSkillVR />} />
          <Route path="/vr-walkthrough" element={<VRWalkthrough />} />
          <Route path="/bathroom-configurator" element={<BathroomConfigurator />} />
          <Route path="/inoviqspace" element={<InoviqSpace />} />
          <Route path="/pixify-archi-walkthrough" element={<PixifyArchiWalkthrough />} />
          <Route path="/office-outlaws" element={<OfficeOutlaws />} />
          <Route path="/office-outlaws-privacy-policy" element={<OfficeOutlawsPrivacyPolicy />} />
          <Route path="/dead-inside" element={<DeadInside />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<RedRenderSite />} />
      </Routes>
    </Router>
  );
};

export default App;
